import { render, staticRenderFns } from "./FieldsetMeterValidityData.yaml?vue&type=template&id=685bccae&component"
import script from "./FieldsetMeterValidityData.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetMeterValidityData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports